'use client';

import React from 'react';
import Link from 'next/link';
import { Home, Search } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen hero-gradient flex flex-col items-center justify-center px-4 py-12 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] opacity-10 animate-rotate-slow"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='200' cy='200' r='190' fill='none' stroke='%23D4AF37' stroke-width='1'/%3E%3Ccircle cx='200' cy='200' r='150' fill='none' stroke='%23D4AF37' stroke-width='0.8'/%3E%3Ccircle cx='200' cy='200' r='110' fill='none' stroke='%23D4AF37' stroke-width='0.8'/%3E%3Ccircle cx='200' cy='200' r='70' fill='none' stroke='%23D4AF37' stroke-width='0.8'/%3E%3C/svg%3E")`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
          }}
        />
        <div className="absolute top-0 right-0 w-80 h-80 rounded-full bg-saffron/15 blur-3xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-gold/10 blur-3xl" />
      </div>

      <div className="relative z-10 text-center max-w-md animate-fade-in-up">
        {/* Logo */}
        <div className="mb-8">
          <Link href="/home-screen" className="inline-flex flex-col items-center gap-3">
            <div className="w-16 h-16 rounded-full saffron-gradient flex items-center justify-center shadow-xl glow-saffron animate-float">
              <span className="text-3xl diya-glow" role="img" aria-label="Diya lamp">🪔</span>
            </div>
            <span className="font-display text-2xl font-bold text-ivory tracking-tight">Yagnick</span>
          </Link>
        </div>

        {/* 404 */}
        <div className="glass-dark rounded-3xl p-8 shadow-2xl border border-gold/30">
          <div className="text-7xl font-display font-bold text-gold/30 mb-2 tabular-nums">404</div>
          <h1 className="font-display text-2xl font-bold text-ivory mb-3">Page Not Found</h1>
          <p className="text-ivory/60 text-sm font-body leading-relaxed mb-8">
            This sacred path doesn&apos;t exist. Let us guide you back to your spiritual journey.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              href="/home-screen"
              className="flex items-center justify-center gap-2 saffron-gradient text-white font-semibold px-6 py-3 rounded-2xl btn-glow text-sm"
            >
              <Home size={16} />
              Go Home
            </Link>
            <Link
              href="/rituals"
              className="flex items-center justify-center gap-2 border border-gold/40 text-ivory/80 hover:text-ivory hover:border-gold font-medium px-6 py-3 rounded-2xl text-sm transition-all"
            >
              <Search size={16} />
              Browse Rituals
            </Link>
          </div>
        </div>

        <p className="text-ivory/30 text-xs mt-6 font-body">
          🙏 Connecting devotees with verified priests across India
        </p>
      </div>
    </div>
  );
}